import { useProductsDynamicData } from "@jti/magento";
import { QueryClient, QueryClientProvider } from "@jti/rest-api";

import { Placeholder } from "@/components/Placeholder/Placeholder";
import type { ProductsMap } from "@/libs/commerce/products";

import { SimpleProductTeaser } from "./SimpleProductTeaser";
import type { simpleProductTeaserInputs } from "./SimpleProductTeaser.builder";

type SimpleProductTeaserProps = BuilderComponentProps<typeof simpleProductTeaserInputs>;

const client = new QueryClient();

export function SimpleProductTeaserDynamicData({
  link,
  name,
  src,
  sku,
}: SimpleProductTeaserProps & { products: ProductsMap }) {
  const productsData = useProductsDynamicData({
    productsSkus: [sku?.options?.product].filter(Boolean),
  });

  const productData = productsData.products[sku?.options?.product]?.productData;

  if (!productData) {
    return <Placeholder>Select proper product or fill custom title and image</Placeholder>;
  }

  return (
    <SimpleProductTeaser
      name={name}
      src={src}
      link={link}
      sku={sku}
      products={{
        [sku?.options?.product]: {
          image: productData.image,
          title: productData.name,
          isTrialProduct: false,
          categoryIds: [],
          categoryNames: [],
        },
      }}
    />
  );
}

export function SimpleProductTeaserAuthorView(props: SimpleProductTeaserProps & { products: ProductsMap }) {
  return (
    <QueryClientProvider client={client}>
      <SimpleProductTeaserDynamicData {...props} />
    </QueryClientProvider>
  );
}
